<template>
  <v-card color="primary" class="rounded-sm">
    <v-card-text v-if="arma">
      <BaseSelect v-model="arma.fk_idEstatus" label="Estatus" :items="estatusArma"></BaseSelect>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton :disabled="loading" :loading="loading" @click="triggerUpdateEstatusArma()">
        Guardar cambios
      </TextButton>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BaseSelect from '../../../base/BaseSelect.vue'
import TextButton from '../../../base/TextButton.vue'

export default {
  components: {
    BaseSelect,
    TextButton,
  },

  data() {
    return {
      selectedArma: null,
      loading: false,
    }
  },

  computed: {
    ...mapGetters('estatusArma', {
      estatusArma: 'getEstatusArma',
    }),
    ...mapGetters('arma', {
      arma: 'getSelectedArma',
    }),
  },

  methods: {
    ...mapActions('arma', ['fetchArmas', 'updateEstatusArma']),

    async triggerUpdateEstatusArma() {
      this.loading = true
      await this.updateEstatusArma({
        idArma: this.arma.idArma,
        fk_idEstatus: this.arma.fk_idEstatus,
      })

      await this.fetchArmas()
    },
  },
}
</script>
